import { ScrollArea } from "@timeghost/ui/shadcn/scroll-area";
import type { ComponentProps, JSX, ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ScrollListProps extends Omit<ComponentProps<typeof ScrollArea>, "children"> {
	readonly children: ReactNode;
}

/**
 * ScrollArea wrapper for non-virtual / grouped listings.
 * Use VirtualScrollList for long flat rows.
 */
export default function ScrollList({ className, children, ...props }: ScrollListProps): JSX.Element {
	return (
		<ScrollArea className={cn("min-h-0 min-w-0", className)} data-slot="scroll-list" {...props}>
			{children}
		</ScrollArea>
	);
}
